<template>
  <b-modal
    id="notInterested"
    centered
    hide-footer
    hide-header
    class="p-0"
    size="md"
    no-close-on-backdrop
    @hidden="closeNotinterestedModal"
  >
    <div class="modalheading d-flex align-items-center justify-content-between">
      <span class="caution-txt">Not Interested Feedback</span>
    </div>

    <hr />
    <div class="xMarkCancel" @click="closeNotinterestedModal">
      <img src="../../../assets/cross-round.svg" alt="" />
    </div>
    <b-overlay :show="showSpinner" rounded="sm">
      <div>
        <div class="mt-3">
          <span class="historymaintext">
            Do you like to change the status of the candidate </span
          ><span class="historysubtext"
            >"{{ notInterestedCandidate.name }}" ?
          </span>
        </div>
        <div class="topDiv mt-4">
          <label class="fieldsetStyle"
            >Remarks &nbsp;<span class="asterik">*</span></label
          >
          <b-form-textarea
            class="inputField"
            id="input-1"
            rows="3"
            placeholder="Enter Remarks . . ."
            max-rows="6"
            type="text"
            v-model="context.$v.notInterestedRemarks.$model"
            :class="{ error: context.$v.notInterestedRemarks.$error }"
            v-on:keyup.enter="notInterested()"
          >
          </b-form-textarea>
          <div
            class="validationicon"
            v-if="
              context.$v.notInterestedRemarks.$dirty &&
              !context.$v.notInterestedRemarks.required
            "
            v-b-popover.hover.top.v-danger="{
              content: 'Required',
            }"
          >
            <img src="../../../assets/deletepopupicon.svg" alt="" />
          </div>
          <div
            class="validationicon"
            v-if="!context.$v.notInterestedRemarks.maxLength"
            v-b-popover.hover.top.v-danger="{
              content: 'Should not exceed 256 characters',
            }"
            variant="primary"
          >
            <img src="../../../assets/deletepopupicon.svg" alt="" />
          </div>
        </div>
        <hr />
        <div class="d-flex align-items-center justify-content-end mt-3">
          <b-button class="addbtn" @click="notInterested()">Update</b-button>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>
import { closeNotinterestedModal } from "../helpers";
import { notInterested } from "../asynchronous";
export default {
  name: "NotInterested",
  props: {
    notInterestedCandidate: Object,
    context: Object,
  },
  data() {
    return {
      showSpinner: false,
    };
  },
  methods: {
    closeNotinterestedModal() {
      closeNotinterestedModal(this.context);
    },
    async notInterested() {
      this.showSpinner = true;
      await notInterested(this.context);
      this.showSpinner = false;
    },
  },
};
</script>
